import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import axiosNew from "../../store/api/axiosNew";
import Logo from "../../assets/logo.png";
import EuctoLogo from "../../Images/EuctoLogoNoText.png";
import "./RetailTransactionInvoice.css";

const RetailTransactionInvoice = () => {
  const { id } = useParams();
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const isAdmin = localStorage.getItem('role') === "admin";
  const token = localStorage.getItem("accessToken");
  const navigate = useNavigate();

  // ---------------- FETCH INVOICE ----------------
  const fetchInvoice = async () => {
    try {
      const res = await axiosNew.get(`/admin/transactions/${id}/invoice`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setInvoiceData(res.data?.data);
    } catch (error) {
      console.error("❌ Failed to fetch invoice", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoice();
  }, []);

  const handleDownload = () => window.print();

  if (loading || !invoiceData) {
    return (
      <div className="loader-wrap">
        <div className="loaderMain"></div>
      </div>
    );
  }

  const {
    invoiceNumber,
    paymentDate,
    paymentMethod,
    status,
    customer,
    items,
    financials,
  } = invoiceData;

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  const currencySymbol = financials?.currency === "INR" ? "₹" : "";

  // ---------------- GST CALCULATION ----------------
  const subtotal = Number(financials?.baseAmount || 0);
  const sgst = Number(financials?.sgst || 0);
  const cgst = Number(financials?.cgst || 0);
  const grandTotal = Number(financials?.total || 0);
  // const sgst = +(subtotal * 0.09).toFixed(2);
  // const cgst = +(subtotal * 0.09).toFixed(2);
  // const grandTotal = subtotal + sgst + cgst;

  return (
    <div className="printable-content">
      <div className="invoice-container p-4">
        {/* ---------- ACTION BAR ---------- */}
        <Row className="mb-3 no-print">
          <Col xs={12} className="text-md-end text-center">
            {!isAdmin && (
              <Button
                variant="secondary"
                onClick={() => navigate("/my-leads-retail")}
                className="me-2"
              >
                Back to My Leads
              </Button>
            )}
            <Button variant="primary" onClick={handleDownload}>
              Download / Print Invoice
            </Button>
          </Col>
        </Row>

        {/* ---------- HEADER ---------- */}
        <Row className="mb-4 align-items-center">
          <Col md={6}>
            <img src={Logo} alt="logo" style={{ width: "160px" }} />
          </Col>
          <Col md={6} className="text-end">
            <h1 className="invoice-title">INVOICE</h1>
          </Col>
        </Row>

        {/* ---------- CUSTOMER ---------- */}
        <Row className="mb-4">
          <Col md={6}>
            <h5 className="mb-0">INVOICE TO</h5>
            <h3>{customer?.name}</h3>
            <p>{customer?.company}</p>
          </Col>
          <Col md={6} className="text-end">
            <p>Invoice No: {invoiceNumber}</p>
            <p>Invoice Date: {formatDate(paymentDate)}</p>
            <p style={{ fontWeight: 600 }}>
              Method: {paymentMethod} <br />
              Status: {status?.toUpperCase()}
            </p>
          </Col>
        </Row>

        {/* ---------- ITEMS ---------- */}
        <div className="table-wrap">
          <Table bordered className="invoice-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Lead ID</th>
                <th>Lead Name</th>
                <th>Purpose</th>

                <th className="text-end">Price</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.userNewLeadId}</td>
                  <td>{item.name}</td>
                  <td>{item.purpose}</td>

                  <td className="text-end">
                    {currencySymbol} {item.subtotal}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* ---------- TOTALS ---------- */}
        <Row className="mt-4">
          <Col md={8}>
            {/* <p>
              <strong>Paid Amount:</strong>{" "}
              <span className="total-due">
                {currencySymbol} {grandTotal.toFixed(2)}
              </span>
            </p> */}
            <p>No dues</p>
          </Col>

          <Col md={4}>
            <p className="text-end">
              Sub Total: {currencySymbol} {subtotal.toFixed(2)}
            </p>
            <p className="text-end">
              SGST : {currencySymbol} {sgst?.toFixed(2)}
            </p>
            <p className="text-end">
              CGST : {currencySymbol} {cgst?.toFixed(2)}
            </p>
            <hr />
            <h4 className="text-end total-amount">
              {/* TOTAL: {currencySymbol} {grandTotal.toFixed(2)} */}
              TOTAL: {currencySymbol} {grandTotal.toFixed(2)}
            </h4>
          </Col>
        </Row>
        <Row className="mt-5 pt-3 border-top">
          <Col className="text-center">
            <img
              src={EuctoLogo}
              alt="EUCTO Logo"
              style={{ width: "100px", marginBottom: "5px" }}
            />
            <p style={{ margin: 0 }}>
              10/1028 Seethakathi 3rd Cross Street, Mogappair East, Chennai
              600037
            </p>
            <p style={{ margin: 0 }}>+91 8754 447057 | hello@eucto.com</p>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default RetailTransactionInvoice;
